/**
 * Substabelecidos Module Routes — granular (2026-04-21)
 */

import { lazy } from "react";
import { ModuleRoutes } from "../types";

const SubstabelecidoListPage = lazy(() =>
  import("@/pages/substabelecidos/SubstabelecidoListPage").then((m) => ({
    default: m.SubstabelecidoListPage,
  }))
);
const SubstabelecidoCreatePage = lazy(() =>
  import("@/pages/admin/SubstabelecidoCreatePage").then((m) => ({
    default: m.SubstabelecidoCreatePage,
  }))
);
const DetalhesSubstabelecido = lazy(() => import("@/pages/substabelecidos/Detalhes"));
const CadastroEdicaoSubstabelecido = lazy(() => import("@/pages/substabelecidos/CadastroEdicao"));
const DashboardPonto = lazy(() => import("@/pages/substabelecidos/DashboardPonto"));

export const substabelecidosRoutes: ModuleRoutes = {
  moduleId: "substabelecidos",
  basePath: "/substabelecidos",
  routes: [
    {
      path: "/substabelecidos",
      element: <SubstabelecidoListPage />,
      permission: { resource: "substabelecidos_lista", action: "view" },
    },
    {
      path: "/substabelecidos/novo",
      element: <SubstabelecidoCreatePage />,
      permission: { resource: "substabelecidos_cadastro", action: "manage" },
    },
    {
      path: "/substabelecidos/:id",
      element: <DetalhesSubstabelecido />,
      permission: { resource: "substabelecidos_detalhe", action: "view" },
    },
    {
      path: "/substabelecidos/:id/editar",
      element: <CadastroEdicaoSubstabelecido />,
      permission: { resource: "substabelecidos_cadastro", action: "manage" },
    },
    {
      path: "/substabelecidos/:id/dashboard-ponto",
      element: <DashboardPonto />,
      permission: { resource: "substabelecidos_dashboard", action: "view" },
    },
  ],
};
